/* Import modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const { randomId } = require('@bluekiri/alexandria/helpers/dataHelpers');
const prototype = require('./prototype');
const config = require('./config');

module.exports = function OriginListClient(selector = '[data-component="OriginList"]', configuration = {}) {
    if (elementExist(selector)) {
        const instance = Object.create(prototype);

        instance.element = document.querySelector(selector);

        instance.config = { ...config(), ...instance.getConfig(), ...configuration };

        instance.id = instance.element.dataset.id || randomId('origin-list');

        if (instance.config.init) instance.initialize();

        return instance;
    }
};
